import React, { FC, MouseEvent } from 'react';
import { Button as Wrapper, Loading, StartIcon, EndIcon } from './styles';
import colors, { Colors } from 'theme/colors';
import { readableColor } from 'polished';

export interface ButtonProps {
    onClick?: (event?: MouseEvent) => void;
    variant?: keyof Colors;
    disabled?: boolean;
    full?: boolean;
    className?: string;
    loading?: boolean;
    rounded?: boolean;
    size?: 'md' | 'lg';
    startIcon?: string;
    iconColor?: string;
    endIcon?: string;
    type?: 'button' | 'submit';
    tabIndex?: number;
    title?: string;
    alignSelf?: 'flex-start' | 'center' | 'flex-end';
    border?: boolean;
    style?: React.CSSProperties;
}

const Button: FC<ButtonProps> = ({
    loading,
    disabled,
    full,
    onClick,
    children,
    variant,
    startIcon,
    endIcon,
    type,
    iconColor,
    rounded = true,
    title,
    ...props
}) => {
    // Button's methods.
    const handleOnClick = (event?: MouseEvent) => {
        if (onClick && (!loading || disabled)) {
            onClick(event);
        }
    };

    // Render.
    const icon = !!(startIcon || endIcon);
    const color = colors[variant || 'primary'];

    return (
        <Wrapper
            startIcon={startIcon}
            endIcon={endIcon}
            loading={loading}
            disabled={disabled || loading}
            full={full}
            rounded={rounded}
            variant={variant}
            onClick={handleOnClick}
            type={type}
            {...props}
        >
            {!endIcon && loading ? (
                <Loading icon={icon} color={readableColor(color)} />
            ) : (
                startIcon && <StartIcon name={startIcon} color={iconColor ?? readableColor(color)} size={1} noMargin={!children} />
            )}
            {children || title}
            {endIcon &&
                (loading ? (
                    <Loading icon={icon} color={readableColor(color)} />
                ) : (
                    <EndIcon name={endIcon} color={readableColor(color)} size={1} noMargin={!children} />
                ))}
        </Wrapper>
    );
};

export default Button;
